module.exports = __webpack_public_path__ + "static/WindingWorlds4-d3473a83b8b4b580f9c677d52daa68e0.webp";